// Librerie
import React from 'react';
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';

//IMG
import sienaImg1 from "../../../public/assets/images/locations/siena1.jpg";
import sienaImg2 from "../../../public/assets/images/locations/siena2.jpg";


// 2. Componente React con TypeScript
const AboutUsMain: React.FC = () => {
    const { t } = useTranslation();

    const caroselImgs = [
        {
            src: "/assets/images/locations/carousel/1.jpg",
        },
        {
            src: "/assets/images/locations/carousel/2.jpg",
        },
        {
            src: "/assets/images/locations/carousel/3.jpg",
        },
        {
            src: "/assets/images/locations/carousel/4.jpg",
        },
        {
            src: "/assets/images/locations/carousel/5.jpg",
        },
        {
            src: "/assets/images/locations/carousel/6.jpg",
        },
        {
            src: "/assets/images/locations/carousel/7.jpg",
        },
        {
            src: "/assets/images/locations/carousel/8.jpg",
        }
    ];
    return (
        <>
            <section className="mb-4">
                <h2>{t('aboutUsPage.sectionTitle')}</h2>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.motto') as string }}></p>
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <img src={sienaImg1} className="img-fluid mb-4 mb-lg-0" alt={`${t('aboutUsPage.altImg1')}`} />
                    </div>
                    <div className="col-12 col-lg-6">
                        <img src={sienaImg2} className="img-fluid mb-4 mb-lg-0" alt={`${t('aboutUsPage.altImg2')}`} />
                    </div>
                </div>
            </section>

            <section className='mb-4'>
                <h2>{t('aboutUsPage.sectionTitle2')}</h2>
                <p className="mb-2">{t('aboutUsPage.para6')}</p>
                <div className="row">
                    <div className="col-12">
                        <Carousel fade>
                            {caroselImgs.map((image, index) => (
                                <Carousel.Item key={index}>
                                    <img src={image.src} className="img-fluid" alt={`${t('aboutUsPage.caroselAlt1')}`} />
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutUsMain;